export function cecAllowed(connection) {
  return !['blocked', 'unavailable'].includes(connection?.cecPath)
    && (!['shared_distribution', 'future_matrix'].includes(connection?.signalPath) || connection.cecPath === 'available');
}

export function hasSourceActivationRoute(screen, connection, trainedPortAvailable, { avoidSourceHome = false } = {}) {
  if (connection.isIgnored || (connection.sourceRole && connection.sourceRole !== 'video_source')) return false;
  const shortcut = connection.connectionConfig?.activationOverride;
  if (!avoidSourceHome && shortcut?.type === 'player_home_cec' && shortcut.status === 'confirmed'
    && Number.isFinite(Date.parse(shortcut.verifiedAt)) && shortcut.evidence && cecAllowed(connection)) return true;
  const method = screen.activationStrategy?.inputSwitching?.defaultMethod || screen.activationStrategy?.inputSwitching?.methods?.[0];
  if (method === 'manual') return false;
  if (method === 'lg_webos') return Boolean(connection.mappingMode === 'confirmed'
    && connection.connectionConfig?.inputRoute?.connector === 'lg_webos_remote'
    && connection.connectionConfig.inputRoute.identityReference === `device:${screen.televisionDeviceId}`
    && connection.connectionConfig.inputRoute.nativeInputId);
  if (method && !['trained_menu', 'android_tv_remote_discrete', 'android_tv_remote_input'].includes(method)) return false;
  return Boolean(trainedPortAvailable || ['android_tv_remote_discrete', 'android_tv_remote_input'].includes(method));
}
